import { ChangeDetectionStrategy, Component } from '@angular/core'
import { Dialog, SharedModule } from '@vendure/admin-ui/core'
import { Observable } from 'rxjs'

@Component({
    selector: 'vdr-order-state-select-dialog',
    templateUrl: './kyc-state-select-dialog.component.html',
    styleUrls: ['./kyc-state-select-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [SharedModule],
})
export class KycStateSelectDialogComponent implements Dialog<string> {
    resolveWith: (result?: string) => void
    nextStates: Observable<string[]>
    message = ''
    cancellable: boolean
    selectedState = ''

    select() {
        if (this.selectedState) {
            this.resolveWith(this.selectedState)
        }
    }

    cancel() {
        this.resolveWith()
    }
}
